import cx from "classnames";

export type HotkeysProps = {
	hotkey: string;
	// "default": for displaying hotkeys on a light colored background
	// "inverse": for displaying hotkeys on a dark colored background
	// "toggleable": for light colored backgrounds that change to a dark background on hover (like DropdownMenuItem)
	type?: "default" | "inverse" | "toggleable";
};

const MAC_HOTKEY_SPLIT_PREFIXES = ["⌘", "⇧", "⌥"];
const WINDOWS_HOTKEY_SPLIT_PREFIXES = ["ctrl", "shift", "alt"];

export const Hotkeys: React.FC<HotkeysProps> = ({ hotkey, type = "inverse" }) => {
	let hotkeys: string[] = [];
	const isMacHotkey = MAC_HOTKEY_SPLIT_PREFIXES.includes(hotkey.toLowerCase().charAt(0));
	const plusSplitHotkey = hotkey.split("+")[0];
	const isWindowsHotkey = plusSplitHotkey
		? WINDOWS_HOTKEY_SPLIT_PREFIXES.includes(plusSplitHotkey.toLowerCase())
		: false;

	if (isMacHotkey) {
		hotkeys = hotkey.split("");
	} else if (isWindowsHotkey) {
		hotkeys = hotkey.split("+");
	} else {
		hotkeys = [hotkey];
	}

	if (hotkeys.length === 0) {
		return null;
	}

	return (
		<span className="space-x-0.5">
			{hotkeys.map((key) => (
				<span
					key={key}
					className={cx(
						"px-1",
						"border",
						"rounded",
						"uppercase",
						type === "inverse" && [
							"border-inverse-primary",
							"group-hover:border-inverse-primary-hover",
							"group-hover:text-inverse-tertiary-hover",
						],
						type === "toggleable" && [
							"border-primary",
							"text-tertiary",
							"group-hover:border-inverse-primary-hover",
							"group-hover:text-inverse-tertiary-hover",
						],
						type === "default" && [
							"border-primary",
							"text-tertiary",
							"group-hover:border-primary-hover",
							"group-hover:text-tertiary-hover",
						]
					)}
				>
					{key}
				</span>
			))}
		</span>
	);
};
